// removed by extract-text-webpack-plugin
module.exports = {"container":"Ra87rprCOC7qYDZEJLYyv","children":"_2cwyAcl3wMK-zuDwzyRXlD"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Exchange/Layout/styles.css
// module id = 1564
// module chunks = 83